import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  actionRequiredCount: 0,
};

export const IntakeWorklistSlice = createSlice({
  name: "intakeWorklist",
  initialState,
  reducers: {
    setActionRequiredCount: (state, action) => {
      state.actionRequiredCount = action.payload ?? 0;
    },
  },
});

export const { setActionRequiredCount } = IntakeWorklistSlice.actions;

export default IntakeWorklistSlice.reducer;
